import { useCallback } from "react"

interface Props {
  propertyName: string
  propertyInitial: string
  visible: boolean
  onOpenTOC: () => void
  tocOpen: boolean
  onScrollToEmergency?: () => void
}

export function StickyTopBar({ propertyName, propertyInitial, visible, onOpenTOC, tocOpen, onScrollToEmergency }: Props) {
  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [])

  return (
    <div className={`gb-topbar${visible ? " gb-topbar--visible" : ""}`}>
      <div className="gb-topbar__inner">
        <button
          className="gb-topbar__identity"
          onClick={scrollToTop}
          type="button"
          aria-label="Scroll to top"
        >
          <span className="gb-topbar__monogram" aria-hidden="true">{propertyInitial}</span>
          <span className="gb-topbar__name">{propertyName}</span>
        </button>
        <div className="gb-topbar__right">
          {onScrollToEmergency && (
            <button
              className="gb-topbar__help-btn"
              onClick={onScrollToEmergency}
              type="button"
              aria-label="Need help?"
            >
              <HelpIcon />
            </button>
          )}
          <button
            className="gb-topbar__sections-btn"
            onClick={onOpenTOC}
            type="button"
            aria-label="Open sections menu"
            aria-expanded={tocOpen}
            aria-haspopup="dialog"
          >
            Sections
            <SectionsChevron />
          </button>
        </div>
      </div>
    </div>
  )
}

function SectionsChevron() {
  return (
    <svg className="gb-topbar__sections-icon" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
      <path d="M3 5l3 3 3-3" />
    </svg>
  )
}

function HelpIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" style={{ width: 16, height: 16 }}>
      <circle cx="8" cy="8" r="6.5" />
      <path d="M6.5 6.5a1.5 1.5 0 0 1 3 0c0 1-1.5 1-1.5 2" />
      <circle cx="8" cy="11" r="0.5" fill="currentColor" stroke="none" />
    </svg>
  )
}
